"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const svgson_1 = require("svgson");
/**
 * @deprecated
 */
class Parser {
    static parse(svg) {
        return typeof svg === 'string' ? svgson_1.parseSync(svg) : svg;
    }
    static stringify(svg) {
        return typeof svg === 'string' ? svg : svgson_1.stringify(svg);
    }
}
exports.default = Parser;
